class NavbarController {
  constructor (VehicleService, UserService, $scope, $state, StoreTypes, Localization, I18n, $log) {
    'ngInject'
    this.vehicleService = VehicleService
    this.userService = UserService
    this.I18n = I18n
    this.isLogged = this.userService.getCurrentToken()
    this.StoreTypes = StoreTypes
    this.$state = $state
    this.$log = $log
    this.type = Localization.getLocalizedAppConfig().type
    if (this.isLogged) {
      this.loaded = this.init()
    }

    $scope.$on('vehicles:update', (event, data) => {
      this.vehicleService.getCurrentUserVehicles()
      .then((vehicles) => {
        this.vehicles = vehicles.length > 0
        return this.vehicleService.getCurrentSelectedVehicle()
      })
      .then((v) => {
        this.vehicle = v
        return this.vehicle
      })
      .catch((err) => {
        this.$log.error('Unable to load Navbar', err)
      })
    })
  }

  init () {
    return this.vehicleService.getCurrentUserVehicles()
    .then((vehicles) => {
      this.vehicles = vehicles.length > 0
      return this.vehicleService.getCurrentSelectedVehicle()
    })
    .then((v) => {
      this.vehicle = v
      return this.vehicle
    })
    .catch((err) => {
      this.$log.error('Unable to load Navbar', err)
    })
  }

  get showNavbar () {
    return this.type === this.StoreTypes.STANDALONE
  }

}

export default NavbarController



// WEBPACK FOOTER //
// ./src/app/common/navbar/navbar.controller.js